var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-collapse',{attrs:{"open":false},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('a',{staticClass:"is-flex"},[_c('b-icon',{attrs:{"icon":"chevron-down"}}),_vm._v(" Объект аренды ")],1)]},proxy:true}])},[_c('pre',[_vm._v(_vm._s(_vm.currentRentSerialized))])])
}
var staticRenderFns = []

export { render, staticRenderFns }